import VForm from "@/vuetify_custom/v-form";
import { VChip, VCard, VCardTitle, VCardText } from "vuetify/lib";
import { common_mixins } from "./EditMixIns.jsx";
import { commonValidateRule } from "../utils";
import styles from "./index.module.less";
const commonValidateRuleGo = commonValidateRule("必选");
export default {
  mixins: [common_mixins],
  computed: {
    contract_types_filter() {
      // const {main_type} = this.params
      return this.contract_types;
    },
    fields() {
      const _this = this;
      const recharge_type = this.params.contract_recharge.recharge_type;
      let after = [];
      if (["online_store", "ad_account"].includes(recharge_type)) {
        after = [
          {
            label: "投放形式",
            key: "advertise_type",
            type: "select_field_v1",
            required: true,
            items: ["KOL", "信息流", "电商", "ASO | ASM | ASA"],
            cols: 3,
            rules: [commonValidateRuleGo],
          },
          {
            label: "投放渠道",
            key: "advertise_channels",
            type: "autocompletes",
            multiple: true,
            required: true,
            items: [
              "小红书",
              "抖音",
              "电商",
              "天猫",
              "微店",
              "B站",
              "知乎",
              "华为",
              "oppo",
              "vivo",
              "小米",
              "苹果",
              "百度",
              "微博",
              "网易有道",
              "腾讯",
              "喜马拉雅",
              "支付宝",
              "Soul",
              "七猫",
            ],
            cols: 6,
            scopedSlots: {
              selection: (data) => {
                return (
                  <VChip
                    class={data.attrs.class}
                    input-value={data.selected}
                    close
                    on={{
                      click: (e) => {
                        e.stopPropagation();
                      },
                      "click:close": () => {
                        const index = data.index;
                        _this.params.contract_recharge.advertise_channels.splice(
                          index,
                          1
                        );
                      },
                    }}
                  >
                    {data.item}
                  </VChip>
                );
              },
            },
          },
        ];
      }
      return [
        {
          label: "充值类型",
          key: "recharge_type",
          type: "select_field_v1",
          required: true,
          items: [
            {
              title: "推广平台账号",
              key: "ad_account",
            },
            {
              title: "店铺平台",
              key: "online_store",
            },
            {
              title: "第三方合作平台（如京东、携程等）",
              key: "other",
            },
          ],
          rules: [commonValidateRuleGo],
          cols: 3,
        },
        ...after,
        // {
        //     label: '账号信息',
        //     key:'advertise_account_id',
        //     type:'autocompletes_async_v1',
        //     'item-value':'id',
        //     'item-text':'account',
        //     api: this.$util.api.customer_select_search,
        //     initList: this.apply_user_list,
        //     cols: 3,
        //     handle_data:({customers}) => {
        //         return customers
        //     },
        // }
      ];
    },
  },
  render() {
    const _this = this;
    return (
      <div class={styles["block-margin"]}>
        <VCard flat light outlined>
          <VCardTitle>充值信息</VCardTitle>
          <VCardText>
            <VForm
              ref="base"
              fields={_this.fields}
              v-model={_this.params.contract_recharge}
            />
          </VCardText>
        </VCard>
      </div>
    );
  },
};
